﻿import { runCallbacks } from './asyncViews';
import { dbfetch } from "./dbfetch";
import { getApiConfig } from "./context";
import { init as initStickyCaptions } from "./_stickyCaption";
import { createElement, unsafeSetHTML } from "./_dom";
import { init as initToolbuttons } from "./actionButtons";

const dashboardViewPlaceholderSelector = ".js-dashboardviewasync";

class AsyncDashboard {
	/** @param {HTMLTableElement[]} rows */
	constructor(rows) {
		this.#rows = rows;
		this.#observeNextRow();
	}

	/** @param {HTMLTableElement} row */
	async #initRow(row) {
		const loadViewPromises = [...row.querySelectorAll(dashboardViewPlaceholderSelector)].map(e => this.#loadView(e));
		await Promise.allSettled(loadViewPromises);
		this.#observeNextRow();
	}

	/** @param {HTMLElement} asyncViewElement */
	async #loadView(asyncViewElement) {
		try {
			const html = await AsyncDashboard.#loadHtml(asyncViewElement.dataset.url);
			await AsyncDashboard.#setHtml(asyncViewElement, html);
		} catch (e) {
			var p = createElement("p", { class: "v3-layout__error v3-error" }, e.message || e.toString());
			asyncViewElement.setAttribute("aria-busy", "false");
			asyncViewElement.querySelector(".v3-layout-view__content").replaceChildren(p);
		}
	}

	#observeNextRow() {
		while(this.#currentRow < this.#rows.length) {
			const row = this.#rows[this.#currentRow++];
			if (row.querySelector(dashboardViewPlaceholderSelector)) {
				this.#progressObserver.observe(row);
				break;
			}
		}
	}

	#rowObserved = ([{ isIntersecting, target: row }]) => {
		if (isIntersecting) {
			this.#progressObserver.unobserve(row);
			this.#initRow(row);
		}
	};

	static async #setHtml(panel, html) {
		const dashboardCell = panel.parentElement;
		await unsafeSetHTML(panel, html, "replace");
		const view = dashboardCell.querySelector(":not(a[name]:empty)");
		initStickyCaptions(view);
		initToolbuttons(view);
		runCallbacks(view);
	}

	static async #loadHtml(url, options = {}) {

		const back = getApiConfig("thisUrl");
		const properUrl = new URL(url, `${location.protocol}//${location.host}`);
		properUrl.searchParams.set("back", back);
		url = properUrl.toString();

		const { timeout = 3 * 60 * 1000 } = options;
		const abortController = new AbortController();
		const abortTimeoutId = setTimeout(() => abortController.abort("Request timeout"), timeout);

		// await delayAsync(timeout);

		const response = await dbfetch(url, { signal: abortController.signal, ...options });
		clearTimeout(abortTimeoutId);
		if (response.ok) {
			const ct = response.headers.get("Content-Type");
			if (/^text\/html(;|$)/.test(ct)) {
				const html = await response.text();
				return html;
			}
			throw new Error("Invalid content: " + ct);
		}
		throw new Error(`ERROR: ${response.status} ${response.statusText}`);
	}

	/** @type {HTMLTableElement[]}*/#rows;
	/** @type {number} */#currentRow = 0;
	/** @type {IntersectionObserver} */#progressObserver = new IntersectionObserver(this.#rowObserved);
}


function init(context, selector = ".js-dashboardasync") {
	new AsyncDashboard([...(context || document).querySelectorAll(selector)]);
}

export { init };